import { Helmet } from 'react-helmet-async';
import { useState, useEffect } from 'react';
// @mui
import { Stack, Typography, Grid, Box } from '@mui/material';
import CardMedia from '@mui/material/CardMedia';

import CircularProgress from '@mui/material/CircularProgress';
import { getDatabase, ref as dbref, runTransaction, set, child, get, update, remove } from 'firebase/database';
import { initializeApp } from 'firebase/app';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const firebaseConfig = {
  apiKey: 'AIzaSyDLVrlBPuai36n-i4F5HQVTjSMkVeGVBak',
  authDomain: 'onetweb-e3d8e.firebaseapp.com',
  databaseURL: 'https://onetweb-e3d8e-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'onetweb-e3d8e',
  storageBucket: 'onetweb-e3d8e.firebasestorage.app',
  messagingSenderId: '60910494595',
  appId: '1:60910494595:web:2dc6bf320d67371af04cb6',
  measurementId: 'G-0ZTHXZBNP9',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const rtdb = getDatabase(app);

// ----------------------------------------------------------------------

export default function Page() {
  const [title, setTitle] = useState('');
  const [subtitle, setSubTitle] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(true);
  const [bgvideo, setbgvideo] = useState(null);
  const [abttitle, setabtTitle] = useState('');
  const [abtdescription, setabtDescription] = useState('');
  const [imgphoto, setimgphoto] = useState(null);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));

  useEffect(() => {
    get(child(dbref(rtdb), `about`))
      .then((snapshot) => {
        if (snapshot.exists()) {
          setTitle(snapshot.val().title);
          setSubTitle(snapshot.val().subtitle);
          setDescription(snapshot.val().description);
          setbgvideo(snapshot.val().bg_fullPath);
          setimgphoto(snapshot.val().img_fullPath);
          setabtTitle(snapshot.val().abttitle);
          setabtDescription(snapshot.val().abtdescription);
          setLoading(false);
        } else {
          setTitle('');
          setSubTitle('');
          setDescription('');
          setbgvideo(null);
          setimgphoto(null);
          setabtTitle('');
          setabtDescription('');
          setLoading(false);
          console.log('No data available');
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  if (loading) {
    return (
      <Grid style={{ width: '100%', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
        <Grid
          style={{
            width: '100%',
            marginTop: 60,
            maxWidth: 1200,
            display: 'flex',
            padding: 25,
            height: '80vh',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box sx={{ display: 'flex' }}>
            <CircularProgress color="inherit" />
          </Box>
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      <Helmet>
        <title> About Us | OneT | Leading DevSecOps Service Provider</title>
      </Helmet>

      <Grid
        style={{
          top: 0,
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        {matches ? (
          <Grid
            style={{
              zIndex: -1,
              position: 'fixed',
              top: 0,
              backgroundColor: '#1b0049',
              width: '100%',
              display: 'flex',
              justifyContent: 'flex-end',
              flexDirection: 'column',
            }}
          >
            <video height="100%" className="videoTag" playsInline autoPlay loop muted>
              <source src={bgvideo} type="video/mp4" />
            </video>
          </Grid>
        ) : (
          <Grid
            style={{
              zIndex: -1,
              position: 'fixed',
              top: 0,
              backgroundColor: '#1b0049',

              height: '110vh',
              display: 'flex',
              justifyContent: 'flex-end',
              flexDirection: 'column',
            }}
          >
            <video height="100%" className="videoTag" playsInline autoPlay loop muted>
              <source src={bgvideo} type="video/mp4" />
            </video>
          </Grid>
        )}

        <Grid
          style={{
            maxWidth: 1200,
            zIndex: 1,
            marginTop: 120,
            width: '100%',
            display: 'flex',
            padding: 25,
            paddingTop: 60,
            paddingBottom: 80,
            flexDirection: 'column',
            justifyContent: 'center',
            backgroundColor: 'Transparent',
          }}
        >
          <Grid container style={{ display: 'flex', width: '100%' }}>
            <Grid item xs={12}>
              <Typography style={{ fontWeight: 'bold', fontSize: 40, color: 'white', textTransform: 'uppercase' }}>
                {title}
              </Typography>
              <Typography
                style={{
                  marginTop: -10,
                  fontWeight: 'lighter',
                  fontSize: 40,
                  color: 'white',
                  textTransform: 'uppercase',
                }}
              >
                {subtitle}
              </Typography>
            </Grid>

            <Grid item md={12} xs={12}>
              <Typography
                sx={{ whiteSpace: 'pre-wrap' }}
                style={{ maxWidth: 500, marginTop: 20, fontWeight: 300, fontSize: 16, color: 'white' }}
              >
                {description}
              </Typography>
            </Grid>
            <Grid item md={12} xs={12}>
              <Grid style={{ marginTop: 10 }}>
                <img src="/assets/bizsafelogo.png" alt="biz safe logo" height={40} />
              </Grid>
              <Grid style={{ marginTop: 10 }}>
                <img src="/assets/dpt_logo.png" alt="Data Protection Trustmark logo" height={50} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          style={{
            zIndex: 1,
            backgroundColor: '#1b0049',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <Grid container spacing={2} style={{ padding: 25, maxWidth: 1200 }}>
            <Grid
              item
              sm={4}
              md={5}
              lg={5}
              xs={12}
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', flexDirection: 'column' }}
            >
              <Grid>
                <Typography style={{ fontWeight: 'bold', fontSize: 24, color: 'white', textTransform: 'uppercase' }}>
                  {abttitle}
                </Typography>
                <Typography style={{ fontSize: 16, maxWidth: 250, color: '#af9ad3', marginTop: 10 }}>
                  {abtdescription}
                </Typography>
              </Grid>
            </Grid>
            <Grid item sm={8} md={7} lg={7} xs={12}>
              <img src={imgphoto} alt="img 1" width="100%" />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
